<template>
  <div class="pa-6">
    <div v-for="(question, index) in questions" :key="question.id">
      <PoeChart :index="index + 1" :question="question" v-if="question.type === 'single'" />
      <v-divider></v-divider>
      <BarChart :index="index + 1" :question="question" v-if="question.type === 'multiple'" />
      <v-divider></v-divider>
      <TextChart :index="index + 1" :question="question" v-if="question.type === 'text'" />
    </div>
  </div>
</template>

<script>
import PoeChart from './PoeChart.vue'
import BarChart from './BarChart.vue'
import TextChart from './TextChart.vue'
import { mapState } from 'vuex'
export default {
  components: { PoeChart, BarChart, TextChart },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      questions: state => state.surveyQuestion.items
    })
  }
}
</script>

<style></style>
